var _g, _line, _line2, _line3, _line4, _line5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDevops4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 122,
    viewBox: "0 0 122 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3455_7616)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9141 26.596C17.9141 16.9298 25.7501 9.09375 35.4164 9.09375H86.9958C96.662 9.09375 104.498 16.9298 104.498 26.596V78.1754C104.498 87.8417 96.662 95.6777 86.9958 95.6777H35.4164C25.7501 95.6777 17.9141 87.8417 17.9141 78.1754V26.596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4164 9.6407H86.9958C96.3599 9.6407 103.951 17.2319 103.951 26.596V78.1754C103.951 87.5396 96.3599 95.1308 86.9958 95.1308H35.4164C26.0522 95.1308 18.461 87.5396 18.461 78.1754V26.596C18.461 17.2319 26.0522 9.6407 35.4164 9.6407Z",
    stroke: "#B1C1CF",
    strokeWidth: 1.09389
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 49.0273,
    y1: 38.8581,
    x2: 73.3791,
    y2: 38.8581,
    stroke: "#243251",
    strokeWidth: 2.70575
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 49.0273,
    y1: 46.9753,
    x2: 73.3791,
    y2: 46.9753,
    stroke: "#243251",
    strokeWidth: 2.70575
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 49.0273,
    y1: 55.0924,
    x2: 73.3791,
    y2: 55.0924,
    stroke: "#243251",
    strokeWidth: 2.70575
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 49.0273,
    y1: 64.5612,
    x2: 73.3791,
    y2: 64.5612,
    stroke: "#243251",
    strokeWidth: 2.70575
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 55.2156,
    y1: 66.6373,
    x2: 65.8246,
    y2: 34.1677,
    stroke: "white",
    strokeWidth: 4.05862
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3455_7616",
    x: 0.41177,
    y: 0.342604,
    width: 121.589,
    height: 121.589,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8.75115
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.75115
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.615686 0 0 0 0 0.686275 0 0 0 0 0.776471 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3455_7616"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3455_7616",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevops4);
export default __webpack_public_path__ + "static/media/Devops4.39f2eeb14561b4cec82989513b9b231a.svg";
export { ForwardRef as ReactComponent };